import React from "react";

import { IUser } from "../../constants/types";
import { normalize } from "../../helpers/normalize";
import useAuth from "../../routes/login/AuthContext";
import { LoadUserInfo } from "../../services/UserApi";
import { createContext } from "../../helpers/createContext";

interface IProps {
  userId: string;
}

interface IUserContext {
  user?: IUser;
  isLoading: boolean;
  loadUser: () => Promise<void>;
}

const [UserContext, useUserContext] = createContext<IUserContext>();

export const UserProvider: React.FC<IProps> = (props) => {
  const [user, setUser] = React.useState<IUser>();
  const { getAuthToken } = useAuth();
  const [isLoading, setIsLoading] = React.useState(false);

  const loadUser = React.useCallback(async () => {
    setIsLoading(true);
    const userInfoResponse = await LoadUserInfo(props.userId, await getAuthToken());

    if (!userInfoResponse.error && userInfoResponse.result) {
      setUser(userInfoResponse.result);
    }

    setIsLoading(false);
  }, [props.userId]);

  React.useEffect(() => {
    loadUser();
  }, [loadUser]);

  const value = React.useMemo(
    () => ({
      user,
      isLoading,
      loadUser,
    }),
    [normalize(user), isLoading, loadUser]
  );

  return <UserContext.Provider value={value} {...props} />;
};

export { useUserContext };
